import React, { useEffect, useState } from "react";
import { getInitials } from "@/utils/functions/helperFunctions";
import { getName, getemail_address } from "@/utils/functions/TokenFunction";
import { cn } from "@/lib/utils";

type Props = {
    id?: string;
    className?: string;
};

const UserInfoCard: React.FC<Props> = ({ id, className }) => {
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");

    useEffect(() => {
        setName(getName());
        setEmail(getemail_address());
    }, []);

    return (
        <div className={cn("dropdown-inner user-card-wrap bg-lighter w-100", className)}>
            <div className="user-card w-100">
                <div className="user-avatar">
                    <span id={`${id}-user-initials`}>{getInitials(name || "")}</span>
                </div>
                <div className="user-info w-100">
                    <span className="lead-text text-capitalize" id={`${id}-user-name`}>
                        {name}
                    </span>
                    <span className="sub-text" id={`${id}-user-email`}>
                        {email}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default UserInfoCard;
